<template>
  <v-container>
  <div id="nonprint">
    <v-btn icon :to="{ path: 'OrderSheet', query: { id: this.applicationid }}">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 px-3 sample-card" ID="">バーコードシート</span>
  </div>

    <v-card flat outlined class="pa-3 nonprint" id="nonprint">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">分析サンプルボトルについてのお願い</span>
       </div>
      <p class="title-1">
        サンプルバーコードを印刷してサンプルボトルに貼り付けてください。印刷にはラベルシート（シールシート）などをご利用いただくと便利です。<br>
        <br>
        （１）<strong>サンプルバーコード</strong>を印刷してください。<br>
        （２）バーコードを切り取り、<strong>サンプルボトルに貼り付けて</strong>ください。<br>
      </p>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="barcodePrint()"
        class="caption"
        >
        <v-icon class="mr-2">mdi-printer</v-icon>
        バーコードシートを印刷する
      </v-btn>
      <p class="mx-3 mt-3 caption">
        ※ご利用の環境（OSやブラウザのバージョンやプリンターなど）によって印刷レイアウトが崩れる場合があります。印刷レイアウトが崩れる場合は、お手数ですが余白や印刷範囲を設定して印刷してください。<br>
      </p>
      <p class="mx-5 mt-3 caption">
        <strong>推奨印刷設定</strong><br>
        用紙サイズ ： A4 縦<br>
        余白(上下) ： 18.5mm<br>
        余白(左右) ： 19.0mm<br>
        4.0cm角のバーコードが 4列×6行= 1ページ24枚印刷されます。
        <br>
      </p>
      <v-row dense class="ml-3">
        <v-col cols="6" lg="2" md="3" sm='4' dense>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model.number="dummyCount"
                label="印刷開始位置調整（ダミー数）"
                dense
              ></v-text-field>
            </template>
            <span>「印刷開始位置調整」で先頭にダミーラベルを挟むことができます。<br>ラベルシートをご利用の場合に、未使用のシール位置から印刷調整する際にご利用ください。</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card>

<!--
  <div class="mt-3">
    <v-card class="px-3">
-->
  <div class="mt-3">
    <v-card class="px-2">
      <v-card-title class="font-weight-bold" id="nonprint">分析サンプル貼り付け用バーコードシート<span class="white--text mb-3">{{  countFor = 0 }}</span></v-card-title>
      <span class="caption ml-4" id="nonprint">お申込み日 : {{ application.createdAt| moment('YYYY[年]MM[月]DD[日]') }}</span>
      <span class="caption ml-4" id="nonprint">サンプル数 : {{ sampleNum }}</span><br id="nonprint">
      <span class="caption ml-4" id="nonprint" v-show="application.OrderNumber">受注番号 : {{ application.OrderNumber }}</span>
      <span class="caption ml-4" id="nonprint" v-show="!application.OrderNumber">受注番号 : 採番待ち</span>
      <br id="nonprint">
      <span class="caption ml-4" id="nonprint">分析依頼者:</span>
      <span id="nonprint">
          &nbsp;
          {{ application.PayCompany }}  
          &nbsp;
          {{ application.PayOffice }}
          &nbsp;
          {{ application.PayDept }}
          &nbsp;
      </span>
      <span id="nonprint" class="font-weight-bold mb-3">{{ application.PayPIC }}</span>
      <v-row class="sample-card-row" dense>

        <!-- ラベルシールを有効活用するためのスペーサー -->
        <v-col cols="3" dense class="sample-card-col" v-for="dummy in dummyCount" :key="dummy">
          <v-card outlined class="sample-card">
            <span class="caption white--text sample-hidden">ダミー:{{ countFor++ }}</span>
          </v-card>
          <div class="pagebreak" v-if="(countFor%24) == 0">{{(countFor/12)+1}}</div>
        </v-col>

        <!-- サンプル情報ここから -->
        <template v-for="item of samples">
<!--      <v-col cols="3" dense v-for="itemy in item.BottleCountNum" :key="itemy"> -->
          <v-col cols="3" dense class="sample-card-col" v-for="itemy in item.BottleCountNum" :key="`${item.id}-${itemy}`">
            <v-card outlined class="sample-card">
              <!-- <div class="px-2 pt-1"> -->
                <!-- <span class="caption" id="sample-title">{{ item.Name }}</span><br> -->
                <!-- <span class="caption" id="sample-title">( {{ item.CustomerMachineID }} )</span><br> -->
                <!-- <span class="caption" id="sample-title">サンプル量：{{ item.Quantity }} ml</span> -->
              <span class="ml-2 mt-1 sample-title ">{{ RepCompanyShort | truncate }}<br></span>
              <span class="ml-2 sample-title">{{ item.Name }}<br></span>
              <span class="ml-2 sample-id">採取日: <b>{{ item.SamplingAt }}</b><br></span>
              <span class="ml-2 sample-id" id="">サンプル: [ <b>{{ numSampleID(item.SampleID) }} </b>]（ <b>{{ itemy }} / {{ item.BottleCount }}</b> ）</span> 
              <span class="caption white--text sample-hidden" id="">{{ countFor++ }}</span> 
              <!-- </div> -->
              <div v-if="itemy == 1" class="pa-0 ma-0" style="text-align: center;">
                <!-- <barcode :value="item.id" format='CODE128' height=40 width=1>バーコードの作成に失敗しました</barcode> -->                  
                <vue-qrcode v-model="item.id" :width=69 :margin=1></vue-qrcode>
              </div>
            </v-card>
<!--
          <div class="pagebreak" v-if="((countFor%24 == 0) && (countFor >= 24))"></div>
            <div class="pagebreak" v-if="(countFor%12) == 0">{{(countFor/12)+1}}</div>
-->

            <div class="pagebreak" v-if="(countFor%24) == 0">-</div>
            <div v-else></div>
          </v-col>
        </template>
        
      </v-row>
      <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
        <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
  </v-container>
</template>

<script>
// import VueBarcode from 'vue-barcode';
//import moment from 'moment'
import { API, graphqlOperation} from "aws-amplify"
import { getApplication, samplesByApplication } from '../graphql/queries'
import VueQrcode from 'vue-qrcode'
import mixin  from '../utils/mixin.js'

export default {
  components: {
    // 'barcode': VueBarcode,
    VueQrcode,
  },
  mixins:[mixin],
  head: {
    title: { inner: 'バーコードシート'},
  },
  data: () => ({
    barcodeValue: '1234567890',
    applicationid: "",
    application: {},
    RepCompanyShort: '',
    samples: [],
    sampleNum: 0,
    cardCount: 1,
    overlayStepper1: true,
    dummyCount: 0,
  }),

  mounted: async function () {
    console.log('aa application id: ', this.$route.query.id)
    this.applicationid = this.$route.query.id
    let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))
    console.log('dataget_success', application)
    this.application = application.data.getApplication
    
    // samplesByApplicationを使用してサンプルを取得
    let samples = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.applicationid, limit: 999}))
    //サンプルIDでソート
    let _samples = samples.data.samplesByApplication.items
    _samples.sort(function(a,b){
        if(a.SampleID < b.SampleID) return -1;
        if(a.SampleID > b.SampleID) return 1;
        return 0;
    });
    this.samples = _samples
    console.log('application', this.application)

    this.barcodeValue = this.applicationid
    this.sampleNum = this.samples.length
    this.RepCompanyShort = this.application.RepCompany.replace(/株式会社|有限会社|合同会社|合資会社|合名会社|一般財団法人|一般社団法人|国立研究開発法人|独立行政法人|学校法人|認定ＮＰＯ法人|公益社団法人|公益財団法人|ＮＰＯ法人|財団法人|公立大学/g,'')

    if (this.samples) {
      for (const value of this.samples) {
        console.log("AnalizeType:", value.AnalizeType)
        let analizeSetList = await this.getAnalizeSetList(value.AnalizeType)
        let analizeItemList = await this.getAnalizeItemList(value.AnalizeType)

        let analyzeTypeNames = []
        if(value.AnalizeSet) {
          let analizeSet = analizeSetList.filter(item => item.Value  == value.AnalizeSet)
//        let analizeSetItems = await this.getAnalizeSetItems(analizeSet[0])
          console.log("analizeSet:", analizeSet)

          console.log("analizeSet.AnalizeItemNames:", analizeSet[0].AnalizeItemNames)
//        analyzeTypeNames.push(analizeSetItems[0].Text + "（" + JSON.parse(analizeSetItems[0].AnalizeItemNames) + "）")
          analyzeTypeNames.push(analizeSet[0].Text + "（" + JSON.parse(analizeSet[0].AnalizeItemNames) + "）")
        }

        let analizeJSON = []
        try {
          analizeJSON = JSON.parse(value.AnalizeItems)
        } catch (e) {
          const replaced = value.AnalizeItems.replace(/'/g,"\"")
          console.log('replaced', replaced)
          analizeJSON = JSON.parse(replaced)
        }
        if (analizeJSON) {
          for (const analizeItem of analizeJSON) {
            let item = analizeItemList.filter(item => item.Value  == analizeItem)
            if(item[0]) {
              analyzeTypeNames.push(item[0].Text)
            }else {
              analyzeTypeNames.push(analizeItem)
            }
          }
        }

        value.AnalizeItemNames = analyzeTypeNames.join(",")
        console.log(value.BottleCountNum)
        value.BottleCountNum = Number(value.BottleCount)
      }

/*
        this.samples.forEach((value, index) => {
        const analyseItemByType = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == value.AnalizeType)
        const analyseSetByType = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == value.AnalizeType)
        var analyzeTypeNames = []

        // setの分析項目名取得 value.AnalizeSet
        if (value.AnalizeSet) {
          const analyseItemBySet = analyseSetByType[0].AnalizeSets.filter(item => item.Value  == value.AnalizeSet)
          console.log(analyseItemBySet[0].AnalizeItems)
          var analizeJSON = ''
          analyzeTypeNames.push(analyseItemBySet[0].Text + "（" + JSON.parse(analyseItemBySet[0].AnalizeItemNames) + "）")

        }
        // 個別の分析項目名取得
        try {
          analizeJSON = JSON.parse(value.AnalizeItems)
        } catch (e) {
          const replaced = value.AnalizeItems.replace(/'/g,"\"")
          console.log('replaced', replaced)
          analizeJSON = JSON.parse(replaced)
        }

        if (analizeJSON) {
          analizeJSON.forEach(valuem => {
            const analiseTypeName = analyseItemByType[0].AnalizeItems.filter(item => item.Value  == valuem)
            if(analiseTypeName[0]) {
              analyzeTypeNames.push(analiseTypeName[0].Text)
            }else{ // 分析項目のデータがなくなった
              analyzeTypeNames.push(valuem)
            }

          })
        }

        this.samples[index].AnalizeItemName = analyzeTypeNames.join(",")
        this.samples[index].BottleCountNum = Number(this.samples[index].BottleCount)
      });
*/
    }
    console.log('samples', this.samples)
    this.overlayStepper1 = false    
  },
  methods: {
    barcodePrint: async function () {
      window.print()
    },
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
  },
  filters: {
    truncate: function(value) {
      var length = 15
      if (value.length <= length ) {
        return value
      }
      return value.substring(0, length) + '..'
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scope>
  .sample-title  {
    font-size : 14px !important;
    padding: 0px !important;
    margin-left: 2px !important;
  }
  .sample-id  {
    font-size : 15px !important;
    padding: 0px !important;
    margin-left: 2px !important;
  }
  .sample-card-row{
    width: 100%;
  }
  .sample-card-col{
    display:block;
  }
  .sample-card {
    height: 280px;
  }

@media print {
  #nonprint { 
    display: none;
  }
  .sample-title  {
    font-size : 10px !important;
    -webkit-transform:scale(0.8);
    -moz-transform:scale(0.8);
    -ms-transform:scale(0.8);
    -o-transform:scale(0.8);
    transform:scale(0.8);
    transform-origin: left center;
    padding: 0px !important;
    margin-left: 2px !important;
    line-height: 1.0;
    width:43mm;
    display:block;
  }
  .sample-id  {
    font-size : 10px !important;
    padding: 0px !important;
    margin-left: 2px !important;
    line-height: 1.3;
    display:block;
  }
  .sample-card-row{
    width: 170mm;
    padding: 0px !important;
    margin: 0px  !important;
  }
  .sample-card-col{
    padding: 0px !important;
    margin: 0px  !important;
  }
  .sample-card {
    padding: 0px !important;
    margin: 0px  !important;
    margin-bottom: 3.2mm !important;
    margin-right: 3.8mm !important;
//    border: none !important;
    width: 40mm;
    height: 40mm;
  }
  .sample-hidden {
    display: none;
  }
  .v-toolbar {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
  .container {
    padding: 0px !important;
    margin: 0px  !important;
  }
  .v-sheet {
    padding: 0px !important;
  }
  .v-card {
    box-shadow: none !important ;
  }
  .pagebreak {
    font-size : 0.5px !important;
    padding: 0px !important;
    margin: 0px  !important;
    page-break-before: always !important;
  }

}
</style>